import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "status"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://play.google.com/store/apps/details?id=com.google.android.apps.fitness&hl=fr&gl=US&pli=1"
}, " pour Android ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://support.google.com/fit/answer/6075067?hl=fr&co=GENIE.Platform%3DiOS"
}, " pour ios (instruction Google Fit sur votre montre) ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://apps.apple.com/app/id1433864494?sjid=5315449962916796590-EU"
}, " App Store ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "status" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://play.google.com/store/apps/details?id=com.google.android.apps.fitness&hl=fr&gl=US&pli=1"
}, " pour Android ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://support.google.com/fit/answer/6075067?hl=fr&co=GENIE.Platform%3DiOS"
}, " pour ios (instruction Google Fit sur votre montre) ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://apps.apple.com/app/id1433864494?sjid=5315449962916796590-EU"
}, " App Store ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "border" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, " Nombre de pas par période: ", -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "detailSteps"
}
const _hoisted_23 = { class: "debug" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, " FITNESS STEPS DATA FORMATTED WITH DETAILS: ", -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 0,
  class: "detailSteps"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, " FITNESS STEPS DATA NO FORMAT: ", -1)
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, " FITNESS STEPS BRUT DATA: ", -1)
const _hoisted_30 = { key: 2 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, " FITNESS DATA: ", -1)
const _hoisted_32 = { key: 3 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, " DEBUG INFO dataFromLoginApi ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, " DEBUG INFO dataFromFitnessApi ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      title: $setup.t('transactionUpdateFootStepTitle'),
      class: "pi pi-pencil",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)))
    }, null, 8, _hoisted_1),
    (_ctx.loginStarted === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!$setup.accessToken || $setup.accessToken === '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Non connecté à votre compte Google. "))
            : (!$setup.dataFromFitnessApi || !$setup.dataFromFitnessApi.data || !$setup.dataFromFitnessApi.data.dataSource || $setup.dataFromFitnessApi.data.dataSource.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createTextVNode(" Connecté à votre compte Google, mais aucune données Google Fitness. "),
                  _hoisted_5,
                  _createTextVNode(" Vous devez utiliser Google Fitness: "),
                  _hoisted_6,
                  _createTextVNode(" ou "),
                  _hoisted_7,
                  _createTextVNode(" - "),
                  _hoisted_8,
                  _hoisted_9,
                  _createTextVNode(" ou une application compatible avec Google Fitness API. ")
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (0 === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createTextVNode(" Steps Counter V8 "),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.login && $setup.login(...args)))
          }, "Login Using Google"),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.refresh && $setup.refresh(...args)))
          }, "Refresh Steps Data"),
          _createElementVNode("div", _hoisted_11, [
            (!$setup.accessToken || $setup.accessToken === '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Non connecté à votre compte Google. "))
              : (!$setup.dataFromFitnessApi || !$setup.dataFromFitnessApi.data || !$setup.dataFromFitnessApi.data.dataSource || $setup.dataFromFitnessApi.data.dataSource.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createTextVNode(" Connecté à votre compte Google, mais aucune données Google Fitness. "),
                    _hoisted_14,
                    _createTextVNode(" Vous devez utiliser Google Fitness: "),
                    _hoisted_15,
                    _createTextVNode(" ou "),
                    _hoisted_16,
                    _createTextVNode(" - "),
                    _hoisted_17,
                    _hoisted_18,
                    _createTextVNode(" ou une application compatible avec Google Fitness API. ")
                  ]))
                : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            ($setup.stepsDataFromFitnessApi)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stepsDataFromFitnessApi, (dataForOneDay, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createTextVNode(_toDisplayString(index + 1) + " Du " + _toDisplayString(dataForOneDay.start) + " au " + _toDisplayString(dataForOneDay.end) + ", ", 1),
                      _createElementVNode("span", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showDetail = !$setup.showDetail))
                      }, "nombre de pas: " + _toDisplayString(dataForOneDay.totalNumberOfSteps), 1),
                      ($setup.showDetail === true && dataForOneDay.stepsDataset && dataForOneDay.stepsDataset[0] &&
            dataForOneDay.stepsDataset[0].points  && dataForOneDay.stepsDataset[0].points.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("pre", null, "              " + _toDisplayString(JSON.stringify(dataForOneDay.stepsDataset, null, 4)) + "\n            ", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            ($setup.stepsDataFromFitnessApi)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stepsDataFromFitnessApi, (dataForOneDay, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      _createTextVNode(_toDisplayString(index + 1) + " Du " + _toDisplayString(dataForOneDay.start) + " au " + _toDisplayString(dataForOneDay.end) + ", nombre de pas: " + _toDisplayString(dataForOneDay.totalNumberOfSteps) + " ", 1),
                      (dataForOneDay.stepsDataset && dataForOneDay.stepsDataset[0] &&
            dataForOneDay.stepsDataset[0].points  && dataForOneDay.stepsDataset[0].points.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("pre", null, "              " + _toDisplayString(JSON.stringify(dataForOneDay.stepsDataset, null, 4)) + "\n            ", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_27,
            ($setup.stepsDataFromFitnessApi)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(JSON.stringify($setup.stepsDataFromFitnessApi, null , 4)), 1))
              : _createCommentVNode("", true),
            _hoisted_29,
            ($setup.stepsBrutDataFromFitnessApi)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(JSON.stringify($setup.stepsBrutDataFromFitnessApi, null , 4)), 1))
              : _createCommentVNode("", true),
            _hoisted_31,
            ($setup.dataFromFitnessApi)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(JSON.stringify($setup.dataFromFitnessApi.data, null , 4)), 1))
              : _createCommentVNode("", true),
            _hoisted_33,
            _createElementVNode("div", null, _toDisplayString($setup.dataFromLoginApi), 1),
            _hoisted_34,
            _createElementVNode("div", null, _toDisplayString(JSON.stringify($setup.dataFromFitnessApi)), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}